import script from "./PCHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PCHeader.vue?vue&type=script&setup=true&lang=ts"

import "./PCHeader.vue?vue&type=style&index=0&id=18a640bb&lang=scss&scoped=true"

import exportComponent from "/home/circleci/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18a640bb"]])

export default __exports__